// extracted by mini-css-extract-plugin
module.exports = {"types-icon":"aa30d277 pl3"};